import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { SeasonResponse } from "~types/season";
import type { StandingConfiguration } from "~types/standingConfiguration";

export const useGetSeasonStandingConfiguration = () => {
  const enhancedRequest = useApi();
  const { organizationId, sport, seasonId } = useParams();

  const url = `${sport}/o/${organizationId}/seasons/${seasonId}?fields=standingConfiguration&include=standingConfigurations`;

  return useQuery({
    queryKey: ["standing-configuration", sport, organizationId, seasonId],
    queryFn: async () => {
      const response: SeasonResponse = await enhancedRequest(url);
      const season = response.data[0];
      const resources = response?.includes?.resources;
      const standingConfiguration =
        resources?.[season?.standingConfiguration?.resourceType ?? ""]?.[season?.standingConfiguration?.id ?? ""];
      return (standingConfiguration as StandingConfiguration) || null;
    },
  });
};
